import gtxLoggedUser from '@getrix/common/js/gtx-logged-user';

const normalizeLanguage = (language) => language.substring(0, 2).toLowerCase();

export const getAppLocale = () => {
    return normalizeLanguage(window.gtxConstants.DEFAULT_LANG) || 'it';
};

export const getAgencyLanguage = () => {
    // es. from it_IT to it-IT
    return gtxLoggedUser('language').replace('_', '-');
};

export const getAgencyLanguageId = () => {
    // es. from it_IT to it
    return gtxLoggedUser('language').substr(0, 2);
};
